import React, { FC } from 'react';
import styled from 'styled-components';
import ImgixWrapper from '../../../../../ImgixWrapper';

const ImageWrapper = styled.div<{ isWiderViewport: boolean }>`
  & img {
    border-radius: 4px;
  }

  ${({ isWiderViewport }) =>
    isWiderViewport
      ? ''
      : `
    & img {
      width: 100%;
    }
  `};
`;

type ImageProps = {
  imageUrl: string;
  alt: string;
  isWiderViewport: boolean;
};

export const Image: FC<ImageProps> = ({ imageUrl, alt, isWiderViewport }) => {
  if (!imageUrl) {
    return null;
  }

  const wideSizing = { width: 132, height: 132 };
  const narrowSizing = {
    sizes: 'auto',
    imgixParams: { ar: '1.9:1' },
  };
  const sizeProps = isWiderViewport ? wideSizing : narrowSizing;

  return (
    <ImageWrapper isWiderViewport={isWiderViewport}>
      <ImgixWrapper src={imageUrl} alt={alt} {...sizeProps} />
    </ImageWrapper>
  );
};
